"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ckeditor4_react_1 = require("ckeditor4-react");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_i18next_1 = require("react-i18next");
var translationHelper_1 = require("../../../helpers/translationHelper");
var LanguageValidation_1 = require("../../../constants/LanguageValidation");
var postSlice_1 = require("../../../features/post/postSlice");
var react_redux_1 = require("react-redux");
var TextEditor_1 = require("../../../constants/TextEditor");
var translationHelper_2 = require("../../../helpers/translationHelper");
var WarningMessage_1 = __importDefault(require("./WarningMessage/WarningMessage"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var TextAreaEditor = function (_a) {
    var value = _a.value, path = _a.path, editorLanguage = _a.editorLanguage, formikProps = _a.formikProps;
    var _b = react_1.useState(null), editor = _b[0], setEditor = _b[1];
    var _c = react_1.useState(editorLanguage === TextEditor_1.LANGUAGES.HY ? true : false), isOpened = _c[0], setIsOpened = _c[1];
    var _d = react_1.useState(false), isInputError = _d[0], setIsInputError = _d[1];
    var isTranslating = react_redux_1.useSelector(postSlice_1.selectIsTranslating);
    var sender = react_redux_1.useSelector(postSlice_1.selectTranslationSender);
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var textEditorData = react_1.useMemo(function () { return translationHelper_2.getTextEditorData(path); }, [path]);
    react_1.useEffect(function () {
        if (isTranslating) {
            if (sender &&
                sender.subjectName === textEditorData.subjectName &&
                sender.translationDirection !==
                    textEditorData.translationDirection) {
                if (sender.subjectIndex !== null &&
                    sender.subjectIndex === textEditorData.subjectIndex) {
                    translateText(formikProps.values[sender.subjectName][sender.subjectIndex][sender.translationDirection], textEditorData.translationDirection);
                }
                else if (sender.subjectIndex === null) {
                    translateText(formikProps.values[sender.subjectName][sender.translationDirection], textEditorData.translationDirection);
                }
            }
        }
    }, [isTranslating]);
    react_1.useEffect(function () {
        return function () {
            setEditor(null);
        };
    }, []);
    react_1.useEffect(function () {
        if (isInputError) {
            setTimeout(function () { return setIsInputError(false); }, 2500);
        }
    }, [isInputError]);
    var validateInputLanguage = function (language, value) {
        return LanguageValidation_1.languageValidators[language].regex.test(value);
    };
    var translateText = function (value, translationDirection) { return __awaiter(void 0, void 0, void 0, function () {
        var toLanguage, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    toLanguage = translationHelper_1.textEditorLangMapper(translationDirection);
                    return [4 /*yield*/, dispatch(postSlice_1.getTranslatedText(value, toLanguage))];
                case 1:
                    data = _a.sent();
                    editor.setData(data.translatedValue);
                    return [2 /*return*/];
            }
        });
    }); };
    var clearTextEditor = function () {
        editor.setData('');
    };
    var toggleCollapse = function () {
        setIsOpened(!isOpened);
    };
    var handleTranslate = function (subjectData) {
        dispatch(postSlice_1.translationStart(subjectData));
    };
    return (react_1.default.createElement(semantic_ui_react_1.Accordion, null,
        react_1.default.createElement(semantic_ui_react_1.Accordion.Title, { active: isOpened, index: 0, onClick: toggleCollapse },
            react_1.default.createElement(semantic_ui_react_1.Icon, { name: "dropdown" }),
            isOpened
                ? t('TRANSLATION.CLOSE_COLLAPSED')
                : t('TRANSLATION.OPEN_COLLAPSED')),
        react_1.default.createElement(semantic_ui_react_1.Accordion.Content, { active: isOpened, style: { width: '100%' } },
            react_1.default.createElement(ckeditor4_react_1.CKEditor, { config: TextEditor_1.config, initData: value, name: path, onInstanceReady: function (editor) {
                    setEditor(editor.editor);
                }, onKey: function (event) {
                    var key = event.data.domEvent.$.key;
                    var ctrlKey = event.data.domEvent.$.ctrlKey;
                    if (!validateInputLanguage(editorLanguage, key) &&
                        key.length === 1 &&
                        !ctrlKey) {
                        setIsInputError(true);
                        event.cancel();
                        event.stop();
                    }
                }, onChange: function (event) {
                    formikProps.setFieldValue(path, event.editor.getData());
                } }),
            isInputError && (react_1.default.createElement(WarningMessage_1.default, { editorLanguage: editorLanguage })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text_editor_actions },
                react_1.default.createElement("button", { className: "btn btn-primary " + styles_module_scss_1.default.editor_btn, disabled: value === '' ? true : false, onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        handleTranslate(textEditorData);
                    } }, t('TRANSLATION.TRANSLATION_BUTTON')),
                react_1.default.createElement("button", { className: "btn btn-primary " + styles_module_scss_1.default.editor_btn, onClick: function (e) {
                        e.stopPropagation();
                        e.preventDefault();
                        clearTextEditor();
                    } }, t('TRANSLATION.CLEAR_BUTTON'))))));
};
exports.default = react_1.memo(TextAreaEditor);
